import OldVines from "../../images/hero-old-vine.jpg";
import SealCollage from "../../images/ovr-seal-collage.jpg";
import { Box } from "../../components/styled-system/Box";
import styled from "styled-components";
import { Form } from "react-bootstrap";
import { useState } from "react";
import "./MainPage.scss";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../paths";
import { SearchOptions } from "../../components/search-options/SearchOptions";
import { AppSeo } from '../../components/app-seo/AppSeo';

import { NavigationLink } from "../../components/styled-system/NavigationLink";
import { useDatabaseInfo } from "../../hooks/useDatabaseInfo";

const PicturePanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(${OldVines});
  background-position: center;
  background-repeat: no-repeat;
  padding: 3rem;
  position: relative;
`;

const SealPicturePanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(${SealCollage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 1400px auto;
  padding: 3rem;
  position: relative;
`;

const SearchPanel = styled.div`
  max-width: 850px;
  width: 100vw;
  padding-bottom: 24px;
  margin: 0 10px;
  background: white;
`;

export const MainPage = () => {
  const databaseInfo = useDatabaseInfo();
  const numberOfRecords = databaseInfo?.numberOfRecords;
  const totalHectares = databaseInfo?.totalHectares;
  const numberOfCultivars = databaseInfo?.numberOfCultivars;
  const numberOfCountries = databaseInfo?.numberOfCountries;
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");

  return (
    <><AppSeo
        title="Home"
        keywords="old vines, vineyards, wine heritage, vintage wines"
      />
    <Box display="flex" 
         flexDirection="column" 
         paddingBottom="50px">
      <PicturePanel className="picture-panel">
        <SearchPanel className="search-panel">
          <div className="description-text-center">   
          </div>
          <Box className="description-text-center">
            The world’s first crowdsourced global database of{" "}
            <NavigationLink to={Paths.oldVinesInfo}>
              <span className="description-text-link">
                living historic vineyard sites.
              </span>
            </NavigationLink>{" "}
            We hope that through greater awareness and attention these vineyards 
            and the wines they produce will survive and thrive. {" "}
            <NavigationLink to={Paths.about}>
              <span className="description-text-link">Learn more</span>.
            </NavigationLink>
          </Box>
          <div className="search-container">
            <div className="search-bar">
              <Box display="flex" mt="20px">
                <Form.Control
                  placeholder="Enter a vineyard name, winery name, region, grape variety, etc"
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyUp={(e) => {
                    if (e.key === "Enter" && searchText) {
                      navigate(`${Paths.vineyards}?search=${searchText}`);
                    }
                  }}
                  className="input-text"
                />
                <button
                  className="button u-ml-small"
                  onClick={() =>
                    navigate(`${Paths.vineyards}?search=${searchText}`)
                  }
                >
                  Search
                </button>
              </Box>
              <Box display="flex">
                  <NavigationLink 
                        className="advanced-search description-text-link" 
                        to={Paths.advancedSearch}>
                          Advanced Search
                  </NavigationLink>
              </Box>
            </div>
            <div className="search-options">
              <SearchOptions
                searchCountry={(country) =>
                  navigate(`${Paths.vineyards}?country=${country}`)
                }
                searchVariety={(variety) =>
                  navigate(`${Paths.vineyards}?variety=${variety}`)
                }
                searchAgeRange={(ageRange) =>
                  navigate(`${Paths.vineyards}?age=${encodeURIComponent(ageRange)}`)
                }
              />
            </div>
          </div>
          {/* {databaseInfo && (numberOfRecords > 0) && 
            <Box className="description-text-center-stats">
              The database contains <b>{numberOfRecords}</b> vineyards and a total of <b>{totalHectares}</b> hectares
            </Box>} */}
          {databaseInfo && numberOfRecords && numberOfRecords > 0 &&
            <div className="stat-cards">
              <div className="stat-card">
                <div className="stat-value">{numberOfRecords?.toLocaleString()}</div>
                <div className="stat-label">Vineyards</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">{totalHectares?.toLocaleString()}</div>
                <div className="stat-label">Hectares</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">{numberOfCultivars?.toLocaleString()}</div>
                <div className="stat-label">Cultivars</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">{numberOfCountries?.toLocaleString()}</div>
                <div className="stat-label">Countries</div>
              </div>
            </div>}
          {databaseInfo && (numberOfRecords === 0) &&
            <Box className="description-text-center-stats">
              The database is currently being updated. Please check back soon!
            </Box>}
        </SearchPanel>
      </PicturePanel>

      <SealPicturePanel className="seal-panel">
        <div className="seal-collage-panel">
          <div className="seal-collage-container">
            <div className="seal-collage-overlay">
              <h2 className="seal-collage-heading">A Mark of Living History</h2>
              <hr className="seal-collage-divider" />
              <p className="seal-collage-text">
                The OVR Seal honors wines grown from the world's oldest vineyards,
                helping wine lovers find them and giving the growers and producers
                behind them a way to stand out.
              </p>
              <NavigationLink to={Paths.seal}>
                <button className="seal-collage-button">LEARN ABOUT THE SEAL</button>
              </NavigationLink>
            </div>
          </div>
        </div>
      </SealPicturePanel>

      <Box className="competition-panel">
        <Box className="competition-heading" mb="1.6rem" mt="4rem">
            Register vineyards, win prizes!
          </Box>
        <Box className="description-text-center-contest">
            Join the <b>Heritage Vine Hunt Contest</b>. Help us register old vineyards around the world and you could win fabulous prizes and (serious) bragging rights.
        </Box> 
        <button
            className="button u-ml-small"
            onClick={() =>
              navigate(`${Paths.contest}`)
            }
          >
            Learn More
          </button>
      </Box>

    </Box>
  </>
  );
};
